export default "__VITE_ASSET__BRETIRWz__"